import {shadows} from "./Elements";

const Button = ({ text, onClick, disabled, color }) => {
    return (
        <button
            className={`w-full p-2 rounded text-white transition duration-300 ${disabled ? "bg-gray-400 cursor-not-allowed" :color} ${shadows.sm}`}
            onClick={onClick}
            disabled={disabled}
        >
            {text}
        </button>
    );
};

export default Button;
